import { render, staticRenderFns } from "./StoreSupplier.vue?vue&type=template&id=488f42a6&"
import script from "./StoreSupplier.vue?vue&type=script&lang=js&"
export * from "./StoreSupplier.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports